import browserHistoryStore from "./browserHistoryStore";
import { useShallow } from "zustand/react/shallow";

const useBrowserHistoryStore = () => {
  const { history, add } = browserHistoryStore(
    useShallow((state) => ({
      history: state.history,
      add: state.add,
    }))
  );

  return { history, add };
};

export default useBrowserHistoryStore;
